import { NEW_SLA_FORMAT } from '@atlassian/jira-servicedesk-sla-panel/src/common/constants';
import type { SLA_DISPLAY_FORMAT } from '@atlassian/jira-servicedesk-sla-panel/src/common/types';
import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import type { RestMetric, SlaMetrics } from '../../types';
import { durationToHumanReadable } from '../duration';

export const transformToState = (data: RestMetric, formatMessage: FormatMessage): SlaMetrics => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const metrics: Record<string, any> = {};
	const calendars = data.calendarRefs;

	data.timeMetrics.forEach((metric) => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const goals: Record<string, any> = {};
		metric.config.goals.forEach((goal) => {
			const { id, duration, subGoals = [], ...values } = goal;
			const calendar = calendars.find(({ id: calId }) => calId === (goal.calendarId ?? -1));
			const transformedSubGoals = subGoals.map((subGoal) => {
				const subGoalCalendar = calendars.find(
					({ id: calId }) => calId === (subGoal.calendarId ?? -1),
				);
				return {
					...subGoal,
					calendarName: subGoalCalendar?.name,
					calendarId: subGoalCalendar?.id,
					duration: durationToHumanReadable(subGoal.duration, formatMessage),
				};
			});
			goals[id] = {
				...values,
				metricId: metric.id,
				duration: durationToHumanReadable(duration, formatMessage),
				calendarName: calendar?.name,
				subGoals: transformedSubGoals,
			};
		});

		const slaDisplayFormat: SLA_DISPLAY_FORMAT = metric.config.slaDisplayFormat ?? NEW_SLA_FORMAT;

		const config = {
			definition: metric.config.definition,
			goals,
			slaDisplayFormat,
		};

		metrics[metric.id] = { name: metric.name, config };
	});

	return {
		canManageFields: data.canManageFields,
		calendarRefs: data.calendarRefs,
		metrics,
	};
};
